import { useBreakpointValue } from "@gluestack-style/react";
import { useGeneratePdf } from "@repo/core/hooks/useGeneratePdf";
import { useNavigation } from "@repo/core/hooks/useNavigation";
import { useRouteParams } from "@repo/core/hooks/useRouteParams";
import { ROUTES } from "@repo/core/routes";
import { ProofOfTransaction } from "@repo/core/services/entities/Transactions";

export const InvoiceReceiptController = () => {
  const isMobile = useBreakpointValue({ base: true, md: false });
  const { viewRef, handleCaptureAndGeneratePDF, isLoading } = useGeneratePdf();
  const { back, replace } = useNavigation();

  const state = useRouteParams();

  const data: ProofOfTransaction = state;

  const handleGoToSales = () => {
    replace(ROUTES.sales);
  };
  return {
    back,
    data,
    isMobile,
    handleGoToSales,
    viewRef,
    handleCaptureAndGeneratePDF,
    isLoading
  };
};
